"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionMessage = void 0;
var Transaction_1 = require("./Transaction");
var Account_1 = require("../account/Account");
var DataWriter_1 = require("../DataWriter");
var Base58_1 = require("../../../crypt/libs/Base58");
var Bytes_1 = require("../Bytes");
var TransactionMessage = /** @class */ (function (_super) {
    __extends(TransactionMessage, _super);
    function TransactionMessage(typeBytes, name, creator, feePow, recipient, timestamp, reference, head, message, encrypted, isText, port, genesis_sign) {
        var _this = _super.call(this, typeBytes, name, creator, feePow, timestamp, reference, port, genesis_sign) || this;
        _this.typeBytes[2] = typeBytes[2] | -128;
        _this.recipient = recipient;
        _this.head = head;
        _this.message = message;
        _this.encrypted = encrypted;
        _this.isText = isText;
        return _this;
    }
    TransactionMessage.prototype.toBytes = function (withSign, releaserReference) {
        return __awaiter(this, void 0, void 0, function () {
            var data, _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        data = new DataWriter_1.DataWriter();
                        _b = (_a = data).set;
                        return [4 /*yield*/, _super.prototype.toBytes.call(this, withSign, releaserReference)];
                    case 1:
                        _b.apply(_a, [_e.sent()]);
                        //WRITE RECIPIENT
                        _d = (_c = data).set;
                        return [4 /*yield*/, Base58_1.Base58.decode(this.recipient.getAddress())];
                    case 2:
                        //WRITE RECIPIENT
                        _d.apply(_c, [_e.sent()]);
                        return [4 /*yield*/, this.headToBytes(data)];
                    case 3:
                        _e.sent();
                        return [4 /*yield*/, this.messageToBytes(data)];
                    case 4:
                        _e.sent();
                        //WRITE ENCRYPTED
                        data.set(this.encrypted);
                        //WRITE ISTEXT
                        data.set(this.isText);
                        return [2 /*return*/, data.data];
                }
            });
        });
    };
    TransactionMessage.prototype.messageToBytes = function (dataWriter) {
        return __awaiter(this, void 0, void 0, function () {
            var bytes, messageBytes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        bytes = this.message;
                        return [4 /*yield*/, Bytes_1.Bytes.intToByteArray(bytes.length)];
                    case 1:
                        messageBytes = _a.sent();
                        dataWriter.set(messageBytes);
                        dataWriter.set(bytes);
                        return [2 /*return*/];
                }
            });
        });
    };
    TransactionMessage.prototype.headToBytes = function (dataWriter) {
        return __awaiter(this, void 0, void 0, function () {
            var bytes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Bytes_1.Bytes.stringToByteArray(this.head)];
                    case 1:
                        bytes = _a.sent();
                        dataWriter.setNumber(bytes.length);
                        dataWriter.set(bytes);
                        return [2 /*return*/];
                }
            });
        });
    };
    TransactionMessage.prototype.getDataLength = function (includeReference) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = TransactionMessage.BASE_LENGTH +
                            TransactionMessage.HEAD_LENGTH;
                        return [4 /*yield*/, Bytes_1.Bytes.stringToByteArray(this.head)];
                    case 1: return [2 /*return*/, (_a +
                            (_b.sent()).length +
                            TransactionMessage.MESSAGE_LENGTH +
                            this.message.length +
                            Transaction_1.Transaction.ENCRYPTED_LENGTH +
                            Transaction_1.Transaction.IS_TEXT_LENGTH)];
                }
            });
        });
    };
    TransactionMessage.RECIPIENT_LENGTH = Account_1.Account.ADDRESS_LENGTH;
    TransactionMessage.BASE_LENGTH = Transaction_1.Transaction.BASE_LENGTH + TransactionMessage.RECIPIENT_LENGTH;
    TransactionMessage.HEAD_LENGTH = 1;
    TransactionMessage.MESSAGE_LENGTH = 4;
    return TransactionMessage;
}(Transaction_1.Transaction));
exports.TransactionMessage = TransactionMessage;
